'use client';

import { observer } from 'mobx-react-lite';
import { Tabs } from './tabs';
import FocusLock from 'react-focus-lock';
import { useTranslations } from '@fshr/context/i18n-context';
import Button from '../button';
import { IconCloseAlt } from '../icon';
import { GlobalStore } from '@fshr/stores';
import { useEffect } from 'react';
import { UserPanelTabId } from '@fshr/shared/types';

export type UserPanelTab = {
	id: UserPanelTabId;
	label?: string;
	getIcon?: () => React.JSX.Element;
	getSection: () => React.JSX.Element;
};

type UserPanelProps = {
	onClose: () => void;
	tabs: UserPanelTab[];
	globalStore?: GlobalStore;
};

const UserPanel = ({ onClose, tabs, globalStore }: UserPanelProps) => {
	const t = useTranslations();
	const setSelectedTab = (tab: UserPanelTabId) => {
		globalStore?.setUserPanelOpenTab(tab);
	};
	const activeTab = tabs.find(tab => tab.id === globalStore?.userPanelOpenTab);

	useEffect(() => {
		if (!activeTab) {
			globalStore?.clearUserPanelOpenTab();
		}
	}, [globalStore?.userPanelOpenTab]);

	return (
		<FocusLock
			whiteList={node => {
				//let webchat have focus
				return !document.getElementById('web-messenger-container')?.contains(node);
			}}
		>
			<div
				role="dialog"
				className="@container/user-panel w-full flex flex-col items-center"
				aria-label={t('User Panel')}
			>
				<section
					className="w-full h-[100px] md:h-[110px] sticky top-0 z-20 bg-surface-translucent backdrop-blur-[50px]"
					aria-label={t('User Panel Tabs')}
				>
					{/* Top Nav */}
					<div>
						{/* Header */}
						<div className="h-[60px] py-[8px] px-[20px] flex flex-row justify-between items-center">
							<div></div>
							<div className="cursor-pointer">
								<Button
									autoFocus
									intent="unstyled"
									className="cursor-pointer"
									onClick={onClose}
									aria-label={t('Close')}
								>
									<IconCloseAlt />
								</Button>
							</div>
						</div>
					</div>
					<Tabs
						tabs={tabs}
						selectedTab={globalStore?.userPanelOpenTab || tabs[0].id}
						onTabSelected={setSelectedTab}
					/>
				</section>
				{activeTab?.getSection()}
			</div>
		</FocusLock>
	);
};

export default observer(UserPanel);
